import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import styles from "./UploadImage.module.scss";
import UploadButton from "./UploadButton";
import { faCircleInfo } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type MultiInputUploadImageProps = {
    label?: string
    placeholder?: string
    varient?: string
    type?: string
    value?: string | number
    [key: string]: any
    required?: boolean
    style?: any
    labelFontWeight?: any
    disabled?: boolean
    icon?: string
    tooltipText?: any
    autoFocus?: any
    text?: string
    name: string
    description?: any
    subLabelStyle?: any
    selectedFiles: any[]
    setSelectedFiles: any
    imagesData?: any
    setDeletedFiles?: any
    setPresignedUrlFileName?: any
    isFetching?: boolean
}

const style = {
    margin: "16px 0px",
    "& .MuiTextField-root": {
        width: "100%",
    },
}

const MultiInputUploadImage = (props: MultiInputUploadImageProps) => {
    return <Box className={styles.upload_image_container}>
        <FormControl sx={props.style ? props.style : style}>
            <FormLabel
                disabled={props?.disabled}
                id={props?.name}
                sx={{ fontWeight: props?.labelFontWeight, width: "100%" }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: "4px", marginBottom: "8px" }}>
                    <Typography>
                        {props?.label}
                    </Typography>
                    {props?.required && <Typography sx={{ color: "#E20000", fontSize: "14px", fontWeight: 500 }}>*</Typography>}
                    <FontAwesomeIcon icon={faCircleInfo} style={{ color: "#9A9EA5", cursor: "pointer" }} onClick={() => props?.handleModal(props?.name)} />
                </Box>
            </FormLabel>
            {props?.multiInputData && props?.multiInputData.map((data: any) => (
                <FormLabel
                    key={data?.name + "label"}
                    id={data?.name}
                    sx={props?.subLabelStyle}
                >
                    <Box
                        key={data?.name + "box"}
                        sx={data?.label ? { display: "flex", alignItems: "center", gap: "20px" } : {}}>
                        {data?.label &&
                            <Typography
                                width={"15%"}
                                key={data?.name + "label"}
                            >
                                {data?.label}
                            </Typography>
                        }
                        <TextField
                            name={data?.name}
                            id={data?.id}
                            key={data?.name + "input"}
                            sx={data?.label ? { width: "85% !important", marginBottom: "12px" } : { width: "100% !important", marginBottom: "12px" }}
                            InputProps={{
                                className: props.disabled ? styles.input__disabled : styles.input,
                            }}
                            FormHelperTextProps={{
                                classes: {
                                    root: styles.input__error_message,
                                },
                            }}
                            type={data?.type}
                            placeholder={data?.placeholder}
                            required={data?.required}
                            variant="standard"
                            label=""
                            disabled={data?.disabled}
                            value={data?.value}
                            onChange={data?.onChange}
                            error={data?.error}
                            helperText={data?.helperText}
                        />
                    </Box>
                </FormLabel>
            ))}
        </FormControl>
        <UploadButton
            fieldName={props.name}
            selectedFiles={props.selectedFiles}
            setSelectedFiles={props.setSelectedFiles}
            error={props.error}
            helperText={props.helperText}
            imagesData={props?.imagesData}
            setDeletedFiles={props?.setDeletedFiles}
            isFetching={props?.isFetching}
        />
    </Box>
}
export default MultiInputUploadImage;